module.exports = __webpack_public_path__ + "static/img/wzry-partners.a80d379c.png";